import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Shell from "@/components/app/Shell";
import CheckInForm from "@/components/app/CheckInForm";
import api from "@/lib/api";
import { TRIBES } from "@/lib/tribes";

export default function CheckInPage() {
  const { childId } = useParams();
  const nav = useNavigate();
  const [child, setChild] = useState(null);

  useEffect(() => { api.get(`/children/${childId}`).then((r) => setChild(r.data)); }, [childId]);

  if (!child) return <Shell><div className="text-ink-mid">Loading…</div></Shell>;
  const tribe = TRIBES[child.tribe] || TRIBES.neutral;

  const dismissed = child.dismissed_symptoms || [];
  const activeSymptoms = (child.top_symptoms || []).filter((k) => !dismissed.includes(k));

  return (
    <Shell>
      <div className="max-w-3xl mx-auto bg-warm-white border rounded-3xl p-8 md:p-12" style={{ borderTop: `3px solid ${tribe.accent}`, borderColor: `${tribe.accent}30`, borderTopWidth: 3, borderTopColor: tribe.accent }}>
        <div className="mb-6">
          <div className="text-xs uppercase tracking-widest font-semibold" style={{ color: tribe.accent }}>Session {child.current_session} · Myo Check-In</div>
          <h1 className="font-display text-3xl font-bold text-navy mt-1">Honest snapshot for {child.name}</h1>
          <p className="text-ink-mid mt-2">Answer as of today. This tracks progress over time — no right or wrong.</p>
        </div>
        <CheckInForm childId={childId} sessionNumber={child.current_session} activeSymptoms={activeSymptoms} tribe={tribe} onDone={() => nav(`/child/${childId}`)} />
      </div>
    </Shell>
  );
}
